__turbopack_context__.v({
  "arrowBtn": "styles-module__nOCi-a__arrowBtn",
  "arrowBtnDisabled": "styles-module__nOCi-a__arrowBtnDisabled",
  "arrowsWrap": "styles-module__nOCi-a__arrowsWrap",
  "carouselContainer": "styles-module__nOCi-a__carouselContainer",
  "description": "styles-module__nOCi-a__description",
  "headerRow": "styles-module__nOCi-a__headerRow",
  "scrollableRowContainer": "styles-module__nOCi-a__scrollableRowContainer",
});
